import React from "react";
import PropTypes from "prop-types";
import ReactModal from 'react-modal';
import { SketchPicker } from 'react-color';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";

// material ui core imports
import {
  Grid,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";

// component imports
import {
  RegularCard,
  ItemGrid,
  Button,
  Info,
  UploadButton,
} from "../../components";

// the iPhone that displays how the application will look
import IPhone from './iphone';

// reducer action imports
import {
  loadTheme,
  editTheme,
} from './reducer/actions';

// modal styles
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 5px;
  border-bottom: 1px solid rgba(153, 153, 153, 0.7);
`
const ModalContent = styled.div`
  position: relative;
  overflow: hidden;
  line-height: 50px;
`
const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  border-top: 1px solid rgba(153, 153, 153, 0.7);
`
const ColorBar = styled.div`
  width: 150px;
  height: 25px;
  border: 1px solid #EDEDED;
  background: ${props => props.background};
`

// custom modal styles
const customModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent'
  },
  content: {
    top: 'calc(50% + 30px)',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px !important',
    width: 'fit-content'
  }
};


// The God Cannon?
// The SUPER God Cannon.

// General view - allows editing of colors for application's front end
class GeneralView extends React.Component {
  // set initial state
  constructor(props)
  {
    super(props);
    this.state = {
      /* used with SketchPicker */
      background: '#FFFFFF',
      parent: '',
      child: '',
      showModal: false,
      original: '#FFFFFF',
    };
  }

  // component did mount
  componentDidMount () {
    this.props.loadTheme();
  }

  // handle change complete
  handleChangeComplete = ({ hex }) => {
    this.setState({background: hex});
  };

  // show modal
  _onShowModal (parent, child, color) {
    this.setState({
      parent: parent,
      child: child,
      background: color,
      showModal: true,
    });
  }

  // close modal
  _onCloseModal () {
    const { parent, child} = this.state;

    var theme = this.props.theme;
    theme[parent][child] = this.state.background;
    this._onUpdateDesign(theme);
    this.setState({ showModal: false });
  }

  // close modal without changing color
  _onCancelModal () {
    this.setState({ showModal: false });
  }

  // update design
  _onUpdateDesign (theme) {
    this.props.editTheme(
      theme,
      this.onSuccess.bind(this),
      this.onError.bind(this)
    );
  }

  uploadImage(parent, child, image) {
    var theme = this.props.theme;
    theme[parent][child] = image;
    this._onUpdateDesign(theme);
  }

  checkStatus(current) {
    var theme = this.props.theme;
    theme['title']['darkStatusBar'] = current;
    this._onUpdateDesign(theme);
  }

  onSuccess() {
    console.log('change successful');
  }

  onError(error) {
    alert(error);
  }

  // render the page
  render() {
    // make sure only authorized Users proceed
		// check for admin rights in general
		if (!this.props.user.hasOwnProperty('admin')) {
			return (
				<Redirect from={'appearance'} to={'dashboard'} key={'invalid'} />
			);
		}
		// check for rights for this page in particular
		if (!this.props.user.admin.master &&
			!this.props.user.admin.hasOwnProperty('appearance'))
		{
			return (
				<Redirect from={'appearance'} to={'dashboard'} key={'noTicket'} />
			);
		}

    // set theme
    const { theme } = this.props;
    // set theme values
    const {
      title = {},
      loyal = {},
      card = {},
      datecircle = {},
      box = {},
      button = {},
      bottom = {},
      notification = {},
      general = {},
    } = theme;

    // render return
    return (
    <Grid container>
      <ItemGrid xs={12} sm={12} md={8}>
        {/* Design card header */}
        <RegularCard
          cardTitle="Design"
          cardSubtitle="Logo, Colors, Homepage Images"
          content={
            <div>
            {/* Color Modal */}
            <ReactModal
              isOpen={this.state.showModal}
              onRequestClose={this._onCloseModal.bind(this)}
              closeTimeoutMS={450}
              contentLabel={'Select Color'}
              ariaHideApp={false}
              style={customModalStyles}
              >
              {/* enable picking out a color */}
              <ModalHeader>Select Color</ModalHeader>
              <ModalContent>
                <SketchPicker
                  color={ this.state.background }
                  onChangeComplete={ this.handleChangeComplete }
                />
              </ModalContent>
              {/* confirm or cancel buttons */}
              <ModalFooter>
                <Button
                  variant='raised'
                  primary={true}
                  onClick={(e) => {this._onCloseModal()} }
                >
                  Ok
                </Button>
                <Button
                  variant='raised'
                  style={{ marginLeft: 20 }}
                  onClick={(e) => {this._onCancelModal()}}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </ReactModal>
            {/* end of color picker modal */}
            <Grid container>
              {/* styles for top navigation */}
              <ItemGrid xs={12} sm={12} md={12}>
                <h6>Title Bar</h6>
              </ItemGrid>
              {/* Background color */}
              <ItemGrid xs={12} sm={4} md={4}>
                <Info> Background</Info>
                <ColorBar
                  background={title.background}
                  onClick={(e) =>
                    this._onShowModal('title', 'background', title.background)
                  }
                />
              </ItemGrid>
              {/* Dark Status Bar toggle */}
              <ItemGrid xs={12} sm={4} md={4}>
               <FormControlLabel
                  control={
                    <Checkbox
                      checked={title.darkStatusBar}
                      onChange={(e, c) => this.checkStatus(c)}
                    />
                  }
                  label="Dark Status Bar"
                />
              </ItemGrid>
              {/* App logo upload */}
               <ItemGrid xs={12} sm={4} md={4}>
                <Info>
                  LOGO (PNG with transparency)
                </Info>
                <UploadButton
                  storage="logo"
                  className="logo-upload-button"
                  value={title.logo}
                  style={{ backgroundColor: title.background }}
                  onUploadComplete={logo => { this.uploadImage('title', 'logo', logo)} }
                />
              </ItemGrid>
            </Grid>
            <Grid container>
              <ItemGrid xs={12} sm={12} md={12}>
                <h6>SCHOOL IMAGES</h6>
              </ItemGrid>
              {/* Front of school image*/}
              <ItemGrid xs={12} sm={4} md={4}>
                <Info>
                  School Front (7:3 Aspect Ratio)
                </Info>
                <UploadButton
                  storage="front"
                  className="logo-upload-button"
                  value={title.front}
                  style={{ backgroundColor: title.background }}
                  onUploadComplete={logo => { this.uploadImage('title', 'front', logo)} }
                />
              </ItemGrid>
              {/* Sports field of school image */}
              <ItemGrid xs={12} sm={4} md={4}>
                <Info>
                  School Sports Field (7:3 Aspect Ratio)
                </Info>
                <UploadButton
                  storage="field"
                  className="logo-upload-button"
                  value={title.field}
                  style={{ backgroundColor: title.background }}
                  onUploadComplete={logo => { this.uploadImage('title', 'field', logo)} }
                />
              </ItemGrid>
            </Grid>
            <Grid container>
              {/* Loyalty Card styles */}
              <ItemGrid xs={12} sm={12} md={12}>
                <h6>Loyalty Card</h6>
              </ItemGrid>
              {/* Background color */}
              <ItemGrid xs={12} sm={3} md={3}>
                <Info>
                  Background
                </Info>
                <ColorBar
                  background={loyal.background}
                  onClick={(e) =>
                    this._onShowModal('loyal', 'background', loyal.background)
                  }
                />
              </ItemGrid>
              {/* Title color */}
              <ItemGrid xs={12} sm={3} md={3}>
                <Info>
                  Title
                </Info>
                <ColorBar
                  background={loyal.title}
                  onClick={(e) =>
                    this._onShowModal('loyal', 'title', loyal.title)
                  }
                />
              </ItemGrid>
              {/* Text color */}
              <ItemGrid xs={12} sm={3} md={3}>
                <Info>
                  Text
                </Info>
                <ColorBar
                  background={loyal.text}
                  onClick={
                    (e) => this._onShowModal('loyal', 'text', loyal.text)
                  }
                />
              </ItemGrid>
              {/* Progress bar color */}
              <ItemGrid xs={12} sm={3} md={3}>
                <Info>Progress</Info>
                <ColorBar
                  background={loyal.progress}
                  onClick={
                    (e) => this._onShowModal('loyal', 'progress', loyal.progress)
                  }
                />
              </ItemGrid>
            </Grid>
            {/* Event Card styles */}
            <Grid container>
              <ItemGrid xs={12} sm={12} md={12}>
                <h6>Card</h6>
              </ItemGrid>
              {/* Background color */}
              <ItemGrid xs={12} sm={4} md={4}>
                <Info>
                  Background
                </Info>
                <ColorBar
                  background={card.background}
                  onClick={
                    (e) => this._onShowModal('card', 'background', card.background)
                  }
                />
              </ItemGrid>
              {/* Title color */}
              <ItemGrid xs={12} sm={4} md={4}>
                <Info>
                  Title
                </Info>
                <ColorBar
                  background={card.title}
                  onClick={
                    (e) => this._onShowModal('card', 'title', card.title)
                  }
                />
              </ItemGrid>
              {/* Subtitle color */}
              <ItemGrid xs={12} sm={4} md={4}>
                <Info>
                  Sub Title
                </Info>
                <ColorBar
                  background={card.subtitle}
                  onClick={
                    (e) => this._onShowModal('card', 'subtitle', card.subtitle)
                  }
                />
              </ItemGrid>
            </Grid>
            {/* Date Circle styles */}
             <Grid container>
              <ItemGrid xs={12} sm={12} md={12}>
                <h6>Date</h6>
              </ItemGrid>
              {/* Date Circle color */}
              <ItemGrid xs={12} sm={4} md={4}>
                <Info>
                  Date Circle
                </Info>
                <ColorBar
                  background={datecircle.background}
                  onClick={
                    (e) => this._onShowModal('datecircle', 'background', datecircle.background)
                  }
                />
              </ItemGrid>
              {/* Date Circle Text color*/}
              <ItemGrid xs={12} sm={4} md={4}>
                <Info>Date Circle Text</Info>
                <ColorBar
                  background={datecircle.text}
                  onClick={
                    (e) => this._onShowModal('datecircle', 'text', datecircle.text)
                  }
                />
              </ItemGrid>
            </Grid>
            {/* Button styles */}
            <Grid container>
              <ItemGrid xs={12} sm={12} md={12}>
                <h6>Button</h6>
              </ItemGrid>
              {/* Button color */}
              <ItemGrid xs={12} sm={4} md={4}>
                <Info>
                  Button Color
                </Info>
                <ColorBar
                  background={button.background}
                  onClick={
                    (e) => this._onShowModal('button', 'background', button.background)
                  }
                />
              </ItemGrid>
              {/* Button Text color */}
              <ItemGrid xs={12} sm={4} md={4}>
                <Info>
                  Button Text Color
                </Info>
                <ColorBar
                  background={button.text}
                  onClick={
                    (e) => this._onShowModal('button', 'text', button.text)
                  }
                />
              </ItemGrid>
            </Grid>
            {/* Box styles */}
            <Grid container>
              <ItemGrid xs={12} sm={12} md={12}>
                <h6>Box</h6>
              </ItemGrid>
              {/* Box Background color */}
              <ItemGrid xs={12} sm={4} md={4}>
                <Info>
                  Background
                </Info>
                <ColorBar
                  background={box.background}
                  onClick={
                    (e) => this._onShowModal('box', 'background', box.background)
                  }
                />
              </ItemGrid>
              {/* Box title color */}
              <ItemGrid xs={12} sm={4} md={4}>
                <Info>
                  Title
                </Info>
                <ColorBar
                  background={box.title}
                  onClick={
                    (e) => this._onShowModal('box', 'title', box.title)
                  }
                />
              </ItemGrid>
              {/* Box Subtitle color */}
              <ItemGrid xs={12} sm={4} md={4}>
                <Info>
                  Sub Title
                </Info>
                <ColorBar
                  background={box.subtitle}
                  onClick={
                    (e) => this._onShowModal('box', 'title', box.subtitle)
                  }
                />
              </ItemGrid>
            </Grid>
            {/* Bottom/Navigation Bar styles*/}
            <Grid container>
              <ItemGrid xs={12} sm={12} md={12}>
                <h6>Bottom Bar</h6>
              </ItemGrid>
              {/* Background color */}
              <ItemGrid xs={12} sm={6} md={6}>
                <Info>
                  Background
                </Info>
                <ColorBar
                  background={bottom.background}
                  onClick={
                    (e) => this._onShowModal('bottom', 'background', bottom.background)
                  }
                />
              </ItemGrid>
              {/* Text/Icon colors */}
              <ItemGrid xs={12} sm={6} md={6}>
                <Info>
                  Text
                </Info>
                <ColorBar
                  background={bottom.text}
                  onClick={(e) =>
                    this._onShowModal('bottom', 'text', bottom.text)}
                />
              </ItemGrid>
            </Grid>
            {/* Notification colors */}
            <Grid container>
              <ItemGrid xs={12} sm={12} md={12}>
                <h6>Notifications</h6>
              </ItemGrid>
              {/* Notification box background*/}
              <ItemGrid xs={12} sm={6} md={4}>
                <Info>
                  Box Background
                </Info>
                <ColorBar
                  background={notification.background}
                  onClick={
                    (e) => this._onShowModal('notification', 'background', notification.background)
                  }
                />
              </ItemGrid>
              {/* Notification Text color */}
              <ItemGrid xs={12} sm={6} md={4}>
                <Info>
                  Text
                </Info>
                <ColorBar
                  background={notification.text}
                  onClick={
                    (e) => this._onShowModal('notification', 'text', notification.text)
                  }
                />
              </ItemGrid>
              {/* Icon colors */}
              <ItemGrid xs={12} sm={6} md={4}>
                <Info>
                  Icons
                </Info>
                <ColorBar
                  background={notification.icon}
                  onClick={
                    (e) => this._onShowModal('notification', 'icon', notification.icon)
                  }
                />
              </ItemGrid>
            </Grid>
            {/* App Background styles */}
            <Grid container>
              <ItemGrid xs={12} sm={12} md={12}>
                <h6>App Background</h6>
              </ItemGrid>
              {/* Background color */}
              <ItemGrid xs={12} sm={6} md={3}>
                <Info>
                  Background
                </Info>
                <ColorBar
                  background={general.background}
                  onClick={
                    (e) => this._onShowModal('general', 'background', general.background)
                  }
                />
              </ItemGrid>
              {/* Title color */}
              <ItemGrid xs={12} sm={6} md={3}>
                <Info>
                  Title
                </Info>
                <ColorBar
                  background={general.title}
                  onClick={(e) => this._onShowModal('general', 'title', general.title)}
                />
              </ItemGrid>
              {/* Subtitle color */}
              <ItemGrid xs={12} sm={6} md={3}>
                <Info>
                  Sub Title
                </Info>
                <ColorBar
                  background={general.subtitle}
                  onClick={
                    (e) => this._onShowModal('general', 'subtitle', general.subtitle)
                  }
                />
              </ItemGrid>
              {/* Text color */}
              <ItemGrid xs={12} sm={6} md={3}>
                <Info>
                  Text
                </Info>
                <ColorBar
                  background={general.text}
                  onClick={
                    (e) => this._onShowModal('general', 'text', general.text)
                  }
                />
              </ItemGrid>
            </Grid>
            {/* Images of the front of a school and its field */}
            </div>
          }
        />
      </ItemGrid>
      {/* Sidebar iPhone that displays style changes */}
      <ItemGrid xs={12} sm={12} md={4}>
        <IPhone theme={theme} />
      </ItemGrid>
    </Grid>
    );
  }
}

GeneralView.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  var theme = state.themeReducer.theme;
  if (typeof theme === 'string') {
    theme = JSON.parse(theme);
  }
  return {
    user: state.authReducer.user,
    theme: theme,
  }
};

const mapDispatchToProps = {
  loadTheme,
  editTheme,
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralView);
